import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ef-subscription__skeleton"
}
const _hoisted_2 = {
  key: 1,
  class: "ef-subscription"
}
const _hoisted_3 = { class: "ef-line" }
const _hoisted_4 = { class: "ef-subscriptionPath__content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ef-line ef-subscription__principal" }, " WIP ", -1)

import {onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import Header from '@/components/Header.vue';
import {storeTraining} from '@/stores/training';
import {AxiosResponse} from "axios";

//Router

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const _storeTraining = storeTraining();

//Data
const subscription = ref({});
const loading = ref(true);

onMounted(() => {
  if (route.params.subscriptionId) {
    const subscriptionId = route.params.subscriptionId as string;
    _storeTraining.getSubscription(subscriptionId).then((response: AxiosResponse) => {
      subscription.value = response;
      loading.value = false;
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, " loading "))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(Header, {
            icone: "fa-solid fa-list-check",
            title: "Inscription"
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createTextVNode(" " + _toDisplayString(subscription.value), 1)
        ])
      ]))
}
}

})